import script from "./Casino.vue?vue&type=script&setup=true&lang=ts"
export * from "./Casino.vue?vue&type=script&setup=true&lang=ts"

import "./Casino.vue?vue&type=style&index=0&id=65909d70&lang=css"

const __exports__ = script;

export default __exports__